<template src="./footerbar.html"></template>

<script>
export default {
};
</script>
